<template>
  <div class="row">
    <div class="form-group col-md-12">
      <div class="card">
        <div class="card-header">
          <span>{{ $t('event.title') }}</span>
          
          <div class="float-right" >
            <a href="#section" name="section" v-on:click="expandOrCollapse">
              <span class="fa fa-expand fa-lg" v-if="!localVisible" ></span>
              <span class="fa fa-compress fa-lg" v-if="localVisible"></span>
            </a>
          </div>
        </div>
        <div class="card-body" v-if="localVisible">
          <div class="row">

            <table class="table table-bordered table-striped" width="100%" cellspacing="0">
              <thead>
                <tr>
                  <th>{{ $t('event.form.name') }}</th>
                  <th class="drop-down-filter">{{ $t('event.form.type') }}</th>
                  <th class="drop-down-filter">{{ $t('event.form.detailType') }}</th>
                  <th class="date-range-filter">{{ $t('event.form.date') }}</th>
                  <th class="no-sort not-export no-filter">&nbsp;</th>
                </tr>
              </thead>
              <tfoot>
                <tr>
                  <th>{{ $t('event.form.name') }}</th>
                  <th class="drop-down-filter">{{ $t('event.form.type') }}</th>
                  <th class="drop-down-filter">{{ $t('event.form.detailType') }}</th>
                  <th class="date-range-filter">{{ $t('event.form.date') }}</th>
                  <th class="no-sort not-export no-filter">&nbsp;</th>
                </tr>
              </tfoot>
              <tbody>
                <tr class="odd" v-if="events.length == 0">
                  <td valign="top" align=center colspan="5" class="dataTables_empty">{{ $t("form.aucun_donne")}}</td>
                </tr>
                <tr v-for="event in events" :key="event.id" v-bind:data-id="event.id" >
                  <td>{{ event.name }}</td>
                  <td>{{ event.typeText }}</td>
                  <td>{{ event.detailTypeText }}</td>
                  <td>{{ event.date | formatDate }}</td>

                  <td class="no-sort" align="center">
                    <a href="#" v-bind:title="$t('form.view_button')" v-on:click.stop="view(event.id)">
                      <span class="fa fa-lg fa-calendar"></span>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {EventServiceClient, EventPersonDto} from '../../shared/service-clients/service-clients'
  import ServiceFactory from '../../shared/service-clients/serviceClientFactory'
  import CrudMixin from '../../shared/Mixin/CrudMixin'
  import SearchMixin from '../../shared/Mixin/SearchMixin'

  export default {
    name: 'ViewEventPerson',
    props: {
      memberId: {
        type: Number,
        required: false,
      },
      userId: {
        type: Number,
        required: false,
      },
      entrepreneurId: {
        type: Number,
        required: false,
      },
      partnerId: {
        type: Number,
        required: false,
      },
    },
    data() {
      return {
        events: [],
        localVisible: true,
      }
    },
    watch: {
      memberId: {
        immediante: true,
        handler: function(val) {
          this.fetchEventData(1, val)
        },
      },
      userId: {
        immediante: true,
        handler: function(val) {
          this.fetchEventData(2, val)
        },
      },
      entrepreneurId: {
        immediante: true,
        handler: function(val) {
          this.fetchEventData(3, val)
        },
      },
      partnerId: {
        immediante: true,
        handler: function(val) {
          this.fetchEventData(4, val)
        },
      },
    },
    inject: ['$validator'],
    mixins: [SearchMixin],
    mounted: function() {},
    created: function() {},
    methods: {
      view: function(id) {
        this.$router.push({name: 'events_view', params: {id: id}})
      },
      fetchData: function() {},
      fetchEventData: function(type, id) {
        let self = this
        let eventService = ServiceFactory.create(EventServiceClient)
        eventService.getEventsForParticipant(type, id).then(res => {
          self.events = res
        })
      },
      expandOrCollapse: function() {
        this.localVisible = !this.localVisible
      },
    },
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/components/events/ViewEventPerson.vue